import React from "react"
import styled from 'styled-components'
import backgroundCodivas from '../Assets/Images/manasWorking.jpg'
import history from "../routes/helper/history";
import CONSTANTS from "../constants";
import ProfileMessage from "../Components/CardsMessages/ProfileMessage";
import InfoMessage from "../Components/CardsMessages/InfoMessage";

const Main = styled.div`
 display: flex;
 justify-content: center;
 height: 100vh;
 background-image: url(${backgroundCodivas}) ;
  background-repeat: no-repeat;
  background-size: cover;

`
const MessagesPanel = styled.div`
  margin-top: 1em;

`

const Home = ( {links} ) => {
  return (
   
   <Main> 
     <MessagesPanel >
      <ProfileMessage/>
     <InfoMessage/>
     </MessagesPanel>
   </Main>


   
  );
};

export default Home;
